import { render, staticRenderFns } from "./ScrollCard.vue?vue&type=template&id=6acd8de0"
import script from "./ScrollCard.vue?vue&type=script&lang=js"
export * from "./ScrollCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports